import { InjectionToken } from '@angular/core';

export const PACKAGE_VERSION = new InjectionToken<string>('packageVersion', { factory: () => '' });
